const textNoSelect = {
  WebkitTouchCallout: 'none' as const, // iOS Safari
  WebkitUserSelect: 'none' as const, // Safari
  KhtmlUserSelect: 'none' as const, // Konqueror HTML
  MozUserSelect: 'none' as const, // Old versions of Firefox
  MsUserSelect: 'none' as const, // Internet Explorer/Edge
  userSelect: 'none' as const // Non-prefixed version, currently supported by Chrome, Opera and Firefox
}

export default textNoSelect
